<template>
  <section class="editor" :class="{ 'is-expanded': expanded }">
    <div class="editor-head"><h2>{{ title }}</h2><button type="button" class="text-button" @click="toggleExpanded">收起</button></div>
    <textarea ref="input" :value="value" :disabled="disabled" :maxlength="6000" :placeholder="placeholder" :aria-label="inputLabel" @input="$emit('input', $event.target.value)" />
    <div class="editor-foot">
      <app-icon name="mic" />
      <span class="hint">可用输入法麦克风说 · {{ value.length }}/6000</span>
      <div class="editor-tools">
        <button v-if="!expanded" type="button" class="editor-icon" aria-label="展开编辑" @click="toggleExpanded"><app-icon name="expand" /></button>
      </div>
    </div>
    <customer-ai-assistant v-if="ai" :customer-id="customerId" :draft-key="draftKey" :content="value" :profile="profile" :profile-values="profileValues" :profile-choices="profileChoices" :disabled="disabled" :allow-keywords="allowKeywords" @apply="apply" @schedule="$emit('schedule', $event)" @profile="$emit('profile', $event)" />
    <button v-if="undo && value === undo.after" type="button" class="text-button" :disabled="disabled" @click="restore">撤销采用建议稿</button>
  </section>
</template>
<script>
import CustomerAiAssistant from './customer-ai-assistant'
import { syncAiModalLock } from '../common/ai'
export default {
  components: { CustomerAiAssistant },
  props: {
    value: { type: String, default: '' }, customerId: { type: [Number, String], default: null },
    draftKey: { type: String, default: '' },
    profile: { type: Object, default: () => ({}) }, inputLabel: { type: String, default: '跟进内容' },
    profileValues: { type: Object, default: () => ({}) }, profileChoices: { type: Object, default: () => ({}) },
    disabled: Boolean, allowKeywords: Boolean, ai: { type: Boolean, default: true },
    title: { type: String, default: '本次跟进' },
    placeholder: { type: String, default: '记录这次沟通：客户想买什么、有哪些顾虑、约定下一步做什么……' }
  },
  data() { return { expanded: false, undo: null } },
  watch: { expanded() { this.$nextTick(syncAiModalLock) } },
  beforeDestroy() { this.$nextTick(syncAiModalLock) },
  methods: {
    focusInput() { this.$refs.input.focus() },
    toggleExpanded() { this.expanded = !this.expanded; this.$nextTick(this.focusInput) },
    apply(data) {
      this.undo = { before: this.value, after: data.content }
      this.$emit('input', data.content)
      if (data.keyword) this.$emit('organized', { keyword: data.keyword })
    },
    restore() { this.$emit('input', this.undo.before); this.undo = null }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/follow-up-editor.vue